<template>
  <div>
    <div class="container">
      <el-page-header class="page-header" @back="goBack" content="分账信息"></el-page-header>
      <div class="card-container">
        <p v-show="amountInfo.payAmount > 0 || amountInfo.unPayAmount > 0">
          截至{{amountInfo.cutOffDate}}，
          <span v-show="amountInfo.payAmount <= 0">您暂无到账金额,</span>
          <span v-show="amountInfo.payAmount > 0">您累计到账{{amountInfo.payAmount}}元,</span>
          <span v-show="amountInfo.unPayAmount <= 0">无待到账金额。</span>
          <span v-show="amountInfo.unPayAmount > 0">待到账{{amountInfo.unPayAmount}}元。</span>
        </p>
        <span v-show="amountInfo.payAmount <= 0 && amountInfo.unPayAmount <= 0">暂无。</span>
      </div>
    </div>
  </div>
  
</template>

<script>
  export default{
    data() {
      return {
        amountInfo:{}
      }
    },
    methods:{
      goBack(){
          this.$router.go(-1)
      },
    },
    created() {
      this.wjtHttp.get(this,'/api/delivery/settle/info',{},true,(res)=>{
          var data = res.data
          if(data.code == 200){
            this.amountInfo = data.data
          }else{
              this.$message({
                  message:(data.msg&&data.msg.length > 0)?data.msg:'获取分账信息异常',
                  type:'error'
              })
          }
        },(err)=>{
            console.log(err)
        })
    }
  }
</script>

<style scoped>
  .container{
      width: 1160px;
      margin: auto auto;
  }
  .page-header{
      width: 1080px;
      margin-top: 30px;
      color: #333333;
      font-size: 20px;
  }
  .page-header>div{
      color:#333333;
      font-size: 20px;
  }
  .card-container{
    width: 100%;
    height: auto;
    display: flex;
    margin-bottom: 20px;
    padding-left: 20px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: start;
    border: 1px solid #F2F2F2;
    margin-top: 20px;
    -webkit-box-shadow: 1px 1px 6px #f2f2f2;
    box-shadow: 1px 1px 6px #f2f2f2;
    font-size: 32px;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/amount.vue